import React from 'react';
import { Page, Document, StyleSheet, View, Font } from '@react-pdf/renderer';
import {
  Footer,
  Header,
  ImpactSection1,
  ImpactSection2,
} from './components/ImpactReport';

Font.register({
  family: 'Trebuchet',
  fonts: [
    {
      src: require('assets/impact-report/trebucbd.ttf'),
      fontWeight: 'bold',
    },
    {
      src: require('assets/impact-report/trebuc.ttf'),
      fontWeight: 'normal',
    },
  ],
});

const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFD100',
    paddingTop: 30,
  },
});

type PdfImpactReportProps = {
  data: any;
};

const ImpactReportPdf = ({ data }: PdfImpactReportProps) => {
  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Header reportData={data} />
        <ImpactSection1 reportData={data} />
        <ImpactSection2 reportData={data} />
        <View style={{ width: '100%', height: 48 }} />
        <Footer />
      </Page>
    </Document>
  );
};
export default ImpactReportPdf;
